import cx from 'classnames';
import {CSSProperties} from 'react';
import {DEFAULT_CANVAS_HEIGHT, DEFAULT_CANVAS_WIDTH} from '~/common/canvas/constants';
import {TemplateOrientationEnum} from '~/common/FabricInvitation/EventCreateDesign/hooks/useOrientation';
import {Video} from '~library/atoms/Video';
import './MaskingFilter.sass';

interface MaskingFilterProps {
  media: string;
  templateDefault: string;
  uyoPosition: {
    left: number;
    top: number;
    height: number;
    width: number;
    scaleX: number;
    scaleY: number;
  };
  isMobile: boolean;
  onLoad?: () => void;
  isVideo?: boolean;
  templateOrientation: TemplateOrientationEnum;
}

export const MaskingFilter = ({
  media,
  templateDefault,
  uyoPosition,
  isMobile,
  onLoad,
  isVideo = false,
  templateOrientation,
}: MaskingFilterProps) => {
  const {left, top, width, height, scaleX, scaleY} = uyoPosition;
  let styles: {
    top: string;
    height: string;
    left?: string;
    width?: string;
    objectFit: string;
  } = {
    top: `${(top / DEFAULT_CANVAS_HEIGHT) * 100}%`,
    height: `${((height * scaleY) / DEFAULT_CANVAS_HEIGHT) * 100}%`,
    objectFit: 'cover',
  };

  styles = isMobile
    ? styles
    : {
        ...styles,
        left: `${(left / DEFAULT_CANVAS_WIDTH) * 100}%`,
        width: `${((width * scaleX) / DEFAULT_CANVAS_WIDTH) * 100}%`,
      };

  if (templateOrientation !== TemplateOrientationEnum.PORTRAIT) {
    styles = {
      objectFit: 'cover',
      height: '100%',
      top: '0',
    };
  }

  return (
    <div className="masking-filter--container">
      <img
        id="masking-filter-uploaded-img"
        className={cx('masking-filter--item masking-filter--img masking-filter--img-landscape')}
        src={media}
        alt=""
        data-qa-id="gallery-template__user-upload"
        style={styles as CSSProperties}
        onLoad={onLoad}
      />

      {isVideo ? (
        <Video
          src={templateDefault}
          id="masking-filter-default-template"
          className="masking-filter--item masking-filter--template"
          data-qa-id="gallery-template__video"
          onCanPlay={onLoad}
        />
      ) : (
        <img
          id="masking-filter-default-template"
          className="masking-filter--item masking-filter--template"
          src={templateDefault}
          alt=""
          data-qa-id="gallery-template__image"
          onLoad={onLoad}
        />
      )}
    </div>
  );
};
